import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PagamentoDespesa } from 'src/app/admihair/api/dto/pagamento-despesa';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PagamentoDespesaService } from 'src/app/admihair/service/pagamento-despesa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-pagamento-despesa-detalhar',
  templateUrl: './pagamento-despesa-detalhar.component.html',
  styleUrls: ['./pagamento-despesa-detalhar.component.scss']
})
export class PagamentoDespesaDetalharComponent implements OnInit {

  permissaoDetalhar: boolean = false;
  loading: boolean = true;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  pagamentoDespesa?: PagamentoDespesa;
  tiposPagamento: TipoPagamento[] = [];
  tipoPagamentoSelecionado?: TipoPagamento;

  @ViewChild('f') form?: NgForm;

  constructor(private activatedRouter: ActivatedRoute,
    private pagamentoDespesaService: PagamentoDespesaService,
    private tipoPagamentoService: TipoPagamentoService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_PAGAMENTO_DESPESA');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarIdPagamento();
    if (this.permissaoDetalhar) {
      this.carregarTiposPagamento();
    }
  }

  carregarTiposPagamento() {
    this.tipoPagamentoService.listarPorEmpresa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.tiposPagamento = data;
          this.carregarPagamentoDespesa();
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  carregarPagamentoDespesa() {
    this.pagamentoDespesaService.buscarPorId(this.id).subscribe({
      next: (data: PagamentoDespesa) => {
        this.pagamentoDespesa = data;
        this.selecionarTipoPagamento();
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    })
  }

  selecionarTipoPagamento() {
    this.tipoPagamentoSelecionado = this.tiposPagamento
      .find(t => t.id === this.pagamentoDespesa?.tipoPagamento)
  }


  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  carregarIdPagamento() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }

}
